module.exports = __webpack_public_path__ + "media/bootstrap-icons/currency-bitcoin-d371855a.svg";